import { API_URL } from 'config';
import { store } from 'store.js';
import { aggiornaVendite, caricamento } from 'features/bi/biSlice';
import axios from 'axios';

const API_VENDITE_URL = `${API_URL}/bi/vendite/`;

const getVendite = async (date) => {
  const data = date.split('-').reverse().join('/');

  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  try {
    const res = await axios.post(API_VENDITE_URL, { utente, pin, data });
    const { successo = false, vendite = [] } = res.data;

    if (!successo) throw new Error(JSON.stringify(res));
    store.dispatch(aggiornaVendite(vendite));
    store.dispatch(caricamento(false));
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert('Unable to load data');
    console.log(e);
  }
};

export { getVendite };
